import Vue from 'vue';
import Router from 'vue-router';

import publicRouter from './public';
import { RouteConfig } from 'vue-router';

import TestComponent from '../views/TestComponent.vue';
import PersonalCenter from '@/views/mine/PersonalCenter.vue';
import StaffCount from '@/views/systemSetting/StaffCount/StaffCount.vue';
import RolePermission from '@/views/systemSetting/RolePermission/RolePermission.vue';
import Welcome from '@/views/Welcome.vue';

import AddStaff from '@/views/systemSetting/StaffCount/AddStaff.vue';
import AddRole from '@/views/systemSetting/RolePermission/AddRole.vue';

import CustomerLevel from '@/views/systemSetting/CustomerLevel.vue';
import ProductStock from '@/views/stockManage/productStock/index.vue';
import ProductionDateStock from '@/views/stockManage/productStock/ProductionDateStock.vue';
import InStock from '@/views/stockManage/inStock/index.vue';
import InStockEdit from '@/views/stockManage/inStock/edit.vue';
import InStockApprove from '@/views/stockManage/inStock/approve.vue';

import OutStock from '@/views/stockManage/outStock/index.vue';
import OutStockDetail from '@/views/stockManage/outStock/detail.vue';
import OutStockEdit from '@/views/stockManage/outStock/createOrEdit.vue';
import StockDetail from '@/views/stockManage/stockDetail/index.vue';

import Materials from '@/views/marketingManage/materials/index.vue';
import MaterialsEdit from '@/views/marketingManage/materials/createOrEdit.vue';

import AddProduct from '@/views/productManage/AddProduct.vue';

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import { UserStore } from '@/store/modules/user';
import { getToken } from '@/utils/auth';
import ProductCategory from '../views/systemSetting/productCategory.vue';
import ProductManage from '../views/productManage/index.vue';
import productDetails from '../views/productManage/productDetails.vue';
import ImportProduct from '@/views/productManage/ImportProduct.vue';
import CapitalAccount from '@/views/finnancialManagement/CapitalAccount.vue';
import CustomerList from '../views/customerManage/customerList/index.vue';
import CustomerCreate from '../views/customerManage/customerList/create.vue';
import CustomerEdit from '../views/customerManage/customerList/edit.vue';
import CustomerDetail from '../views/customerManage/customerList/detail.vue';
import CustomerDiscount from '../views/customerManage/customerDiscount/index.vue';
import CustomerDiscountCreate from '../views/customerManage/customerDiscount/create.vue';
import IncomeExpenditureDetail from '@/views/finnancialManagement/IncomeExpenditureDetail.vue';
import ImportCustomer from '@/views/customerManage/ImportCustomer.vue';
import orderList from '@/views/orderManage/orderList.vue';
import orderDetails from '@/views/orderManage/orderDetails.vue';
import ShipmentManagement from '@/views/orderManage/shipmentsManagement/index.vue';
import Allocation from '@/views/orderManage/allocation/index.vue';
import RechargeList from '@/views/finnancialManagement/RechargeList.vue';
import MaterialsView from '@/views/marketingManage/materials/view.vue';

import ShipmentList from '@/views/orderManage/shipmentsManagement/list.vue';
import ShipmentPrint from '@/views/orderManage/shipmentsManagement/print.vue';
import ShunFengPrint from '@/views/orderManage/shipmentsManagement/shunfengPrint.vue';
import ZhongTongPrint from '@/views/orderManage/shipmentsManagement/zhongtongPrint.vue';

import ComissionList from '@/views/report/comission/index.vue';
import GoodReportList from '@/views/report/good/index.vue';
import StockReport from '@/views/report/stock/index.vue';

Vue.use(Router);

const routers: RouteConfig[] = publicRouter.concat([
  {
    path: '/',
    name: 'home',
    component: Welcome //TestComponent
  },
  {
    path: '/testComponent',
    name: 'testComponent',
    component: TestComponent
  },
  {
    path: '/personalCenter',
    name: 'PersonalCenter',
    component: PersonalCenter
  },
  // 系统设置
  {
    path: '/productCategory',
    name: 'productCategory',
    component: ProductCategory
  },
  {
    path: '/staffCount',
    name: 'staffCount',
    component: StaffCount
  },
  {
    path: '/staffCount/create',
    name: 'staffCount_create',
    component: AddStaff
  },
  {
    path: '/rolePermission/create',
    name: 'rolePermission_create',
    component: AddRole
  },
  {
    path: '/rolePermission',
    name: 'rolePermission',
    component: RolePermission
  },
  {
    path: '/customerLevel',
    name: 'customerLevel',
    component: CustomerLevel
  },

  // 商品管理
  {
    path: '/productManage',
    name: 'productManage',
    component: ProductManage
  },
  {
    path: '/productManage/addExcel',
    name: 'productManageAddExcel',
    component: ImportProduct
  },
  {
    path: '/productManage/create',
    name: 'productManage_create',
    component: AddProduct
  },
  {
    path: '/productManage/details',
    name: 'productManage_details',
    component: productDetails
  },
  //库存管理
  {
    path: '/productStock',
    name: 'productStock',
    component: ProductStock
  },
  {
    path: '/productionDateStock',
    name: 'productionDateStock',
    component: ProductionDateStock
  },
  {
    path: '/inStock',
    name: 'inStock',
    component: InStock
  },
  {
    path: '/inStock/create',
    name: 'inStock_create',
    component: InStockEdit
  },
  {
    path: '/inStock/edit',
    name: 'inStock_edit',
    component: InStockEdit
  },
  {
    path: '/inStock/approve',
    name: 'inStock_approve',
    component: InStockApprove
  },
  {
    path: '/inStock/detail',
    name: 'inStock_detail',
    component: InStockApprove
  },
  {
    path: '/outStock',
    name: 'outStock',
    component: OutStock
  },
  {
    path: '/outStock/detail',
    name: 'outStock_detail',
    component: OutStockDetail
  },
  {
    path: '/outStock/approve',
    name: 'outStock_approve',
    component: OutStockDetail
  },
  {
    path: '/outStock/create',
    name: 'outStock_create',
    component: OutStockEdit
  },
  {
    path: '/outStock/edit',
    name: 'outStock_edit',
    component: OutStockEdit
  },
  {
    path: '/stockDetail',
    name: 'stockDetail',
    component: StockDetail
  },
  // 客户管理
  {
    path: '/customer',
    name: 'customer_index',
    component: CustomerList
  },
  {
    path: '/customer/create',
    name: 'customer_create',
    component: CustomerCreate
  },
  {
    path: '/customer/edit',
    name: 'customer_edit',
    component: CustomerEdit
  },
  {
    path: '/customer/detail',
    name: 'customer_detail',
    component: CustomerDetail
  },
  {
    path: '/customerDiscount',
    name: 'customerDiscount',
    component: CustomerDiscount
  },
  {
    path: '/customerDiscount/create',
    name: 'customerDiscount_create',
    component: CustomerDiscountCreate
  },
  // 财务管理
  {
    path: '/finnancialManagement/capitalAccount',
    name: 'capitalAccount',
    component: CapitalAccount
  },
  {
    path: '/finnancialManagement/incomeExpenditureDetail',
    name: 'incomeExpenditureDetail',
    component: IncomeExpenditureDetail
  },
  {
    path: '/importCustomer',
    name: 'importCustomer',
    component: ImportCustomer
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: orderList
  },
  {
    path: '/orderList/details',
    name: 'orderList_details',
    component: orderDetails
  },
  {
    path: '/orderManage/shipmentManagement',
    name: 'shipmentManagement',
    component: ShipmentManagement
  },
  {
    path: '/orderManage/shipmentList',
    name: 'shipmentList',
    component: ShipmentList
  },
  {
    path: '/orderManage/allocation',
    name: 'allocation_index',
    component: Allocation
  },
  {
    path: '/orderManage/shipmentPrint',
    name: 'shipmentPrint',
    component: ShipmentPrint,
    meta: {
      public: true
    }
  },
  {
    path: '/orderManage/shufengPrint',
    name: 'shufengPrint',
    component: ShunFengPrint,
    meta: {
      public: true
    }
  },
  {
    path: '/orderManage/zhongtongPrint',
    name: 'zhongtongPrint',
    component: ZhongTongPrint,
    meta: {
      public: true
    }
  },
  {
    path: '/finnancialManagement/rechargeList',
    name: 'rechargeList',
    component: RechargeList
  },
  {
    path: '/report/commision_list',
    name: 'commision_list',
    component: ComissionList
  },
  {
    path: '/report/good_report_list',
    name: 'good_report_list',
    component: GoodReportList
  },
  {
    path: '/report/stock_report',
    name: 'stock_report',
    component: StockReport
  },
  // 营销管理
  {
    path: '/materials',
    name: 'materials',
    component: Materials
  },
  {
    path: '/materials/view',
    name: 'materials_view',
    component: MaterialsView
  },
  {
    path: '/materials/create',
    name: 'materials_create',
    component: MaterialsEdit
  },
  {
    path: '/materials/edit',
    name: 'materials_edit',
    component: MaterialsEdit
  }
]);

const router = new Router({
  mode: 'history',
  routes: routers
});

const whiteList = ['/login'];

router.beforeEach((to, from, next) => {
  NProgress.start();
  var token = getToken();
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' });
    } else {
      if (!UserStore.name) {
        UserStore.GetUserInfo()
          .then(() => {
            next();
          })
          .catch((err: any) => {
            UserStore.FedLogOut().then(() => {
              next({ path: '/' });
            });
          });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`); // Redirect to login page
    }
  }
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
